<script>
  import SearchItem from './SearchItem.vue'
  import axios from 'axios';

  export default {
    components: {
      SearchItem
    },
    data: () => ({
      searchTerm: '',
      lastTerm: null,
      showSearchResults: true,
      searchEntities: [],
      position: {x: 0, y: 0},
    }),
    methods: {
      searchInput() {
        if (this.searchTerm.length > 2) {

          let currentTerm = (' ' + this.searchTerm).slice(1);

          setTimeout(() => {

            if (this.searchTerm !== currentTerm) {
              return;
            }

            axios.post('/tourclient/api/SearchEntities', {SearchTerm: this.searchTerm}, {
//            headers: {
//              'Content-Type': 'application/json',
//              'Accept': 'application/json'
//            }
            }).then(resp => {

              if (this.searchTerm !== currentTerm) {
                return;
              }

              this.searchEntities = resp.data.Entities;
              this.showSearchResults = false;
              this.lastTerm = currentTerm;

              let position = this.getPosition();
              this.position.x = position.x;
              this.position.y = position.y;
              this.$nextTick(() => {
                this.showSearchResults = true
              });
            });
          }, 400);
        } else {
          this.searchEntities = [];
        }
      },
      getPosition() {
        let el = document.querySelector('.context-entities-search');

        for (var lx = 0, ly = el.offsetHeight; el != null;
             lx += el.offsetLeft,
               ly += el.offsetTop,
               el = el.offsetParent);

        return {x: lx,y: ly};
      }
    },
  };
</script>
<template>
  <div class="context-entities-search">
    <v-menu
      v-model="showSearchResults"
      :position-x="position.x"
      :position-y="position.y"
      absolute
      offset-y
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <div style="margin-right: 15px; background-color: #ffffff;padding: 10px;min-width: 550px;">
          <v-text-field
            v-model="searchTerm"
            placeholder="Поиск заявок/обращений/туристов/партнеров/платежей/задач/сертификатов"
            :hide-details="true"
            @input="searchInput"
          ></v-text-field>
        </div>
      </template>
      <v-list v-if="searchEntities.length">
        <SearchItem v-for="(item, index) in searchEntities" :item="item" :index="index">
        </SearchItem>
      </v-list>
      <v-list v-else-if="lastTerm && searchTerm.length">
        <v-list-item :key="0">
          <v-list-item-title>По запросу "{{lastTerm}}" данных не найдено</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>